export default `ids-block-grid-item img {
  margin-block-end: var(--ids-block-grid-margin);
}

.ids-block-grid-wrapper {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: var(--ids-space-none);
  text-align: center;
}

:host(.ids-align-center) {
  text-align: center;
}

:host(.ids-align-left) {
  text-align: left;
}

:host(.ids-align-right) {
  text-align: right;
}

::slotted(ids-block-grid-item) {
  padding: var(--ids-block-grid-item-padding);
  position: relative;
  vertical-align: top;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtYmxvY2stZ3JpZCIsInNvdXJjZXMiOlsiaWRzLWJsb2NrLWdyaWQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyJpZHMtYmxvY2stZ3JpZC1pdGVtIHtcbiAgaW1nIHtcbiAgICBtYXJnaW4tYmxvY2stZW5kOiB2YXIoLS1pZHMtYmxvY2stZ3JpZC1tYXJnaW4pO1xuICB9XG59XG5cbi5pZHMtYmxvY2stZ3JpZC13cmFwcGVyIHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgbWFyZ2luOiB2YXIoLS1pZHMtc3BhY2Utbm9uZSk7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuOmhvc3QoLmlkcy1hbGlnbi1jZW50ZXIpIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG46aG9zdCguaWRzLWFsaWduLWxlZnQpIHtcbiAgdGV4dC1hbGlnbjogbGVmdDtcbn1cblxuOmhvc3QoLmlkcy1hbGlnbi1yaWdodCkge1xuICB0ZXh0LWFsaWduOiByaWdodDtcbn1cblxuOjpzbG90dGVkKGlkcy1ibG9jay1ncmlkLWl0ZW0pIHtcbiAgcGFkZGluZzogdmFyKC0taWRzLWJsb2NrLWdyaWQtaXRlbS1wYWRkaW5nKTtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB2ZXJ0aWNhbC1hbGlnbjogdG9wO1xufVxuIl19 */`;
